import { combineReducers } from "@reduxjs/toolkit";
import modalReducer from "./slices/sourceConnectionsData";

import nameDescriptionReducer from './UserManagement/addRoleSlice';
import rolesDetailsSlice from './UserManagement/rolesDetailsSlice';
import addUserSlice from './UserManagement/addUserSlice';
import rolesListSlice from './UserManagement/rolesListSlice';
import UserListSlice from './UserManagement/UserListSlice';
import pipelineDashboardSlice from './slices/pipelineDashboard';

import PipelineModal from './modalSlice/PipelineModalSlice';
import ProjectModal from './modalSlice/ProjectListModalSlice';
import projectReducer from './ProjectSlice/projectsSlice';
import tenantSlice from "./tenantSlice/tenantSlice";
import entitySlice from "./entitySlice/entitySlice";
import sidenavSlice from "./sidenavSlice/sidenavSlice";
import deduplicationWorkflowData from "./deduplicationSlice/deduplicationSlice";
import unstructuredToStructuredSlice from './wormholeSlice/unstructuredToStructured';
import fileSlice from './wormholeSlice/fileSlice';
import taskSlice from './wormholeSlice/taskSlice';

import reportBuilderSlice from "./report-builder-slice/reportBuilderSlice";
import taxonomySlice from "./TaxonomySlice/formSlice";
import onePlatformPipelineSlice from "./oneplatformPipelineSlice/oneplatformPipelineSlice";
import wormholePipelineDashboardSlice from "./wormholePipelineSlice/pipelineDashboard";
import wormholeCreatePipelineSlice from "./wormholePipelineSlice/createPipeline";
import schedulerSlice from "./wormholeSlice/schedulerSlice";
import profilerSlice from "./dataNexusV2-profilerSlice/profilerSlice";
import authSlice from "./authSlice/authSlice";
import biPortalSlice from "./biPortalSlice/biPortalSlice";
import modalReducers from '../pages/P.AI/redux-toolkit/slices/ModalSlice';
import userManagementReducer from '../pages/P.AI/redux-toolkit/slices/UserManagentSlice';
import rolesReducer from '../pages/P.AI/redux-toolkit/slices/RolesSlice';
import roleReducer from '../pages/P.AI/redux-toolkit/slices/roleSlice';
import authReducer from '../pages/P.AI/redux-toolkit/slices/AuthSlice';
const appReducer = combineReducers({
  nameDescription: nameDescriptionReducer,
  rolesDetails: rolesDetailsSlice,
  modal: modalReducer,
  addUserDetails: addUserSlice,
  rolesListData: rolesListSlice,
  userListData: UserListSlice,
  pipelineDashboardSlice: pipelineDashboardSlice,
  ModalData: PipelineModal,
  ProjectModalData: ProjectModal,
  projects: projectReducer,
  tenants: tenantSlice,
  Entity: entitySlice,
  sidenavSettings: sidenavSlice,
  unstructuredToStructured: unstructuredToStructuredSlice,
  file: fileSlice,
  taskReducer: taskSlice,
  reportBuilderSlice: reportBuilderSlice,
  taxonomySlice: taxonomySlice,
  sheduleReducer: schedulerSlice,
  onePlatformPipelineSlice: onePlatformPipelineSlice,
  wormholePipelineDashboardSlice: wormholePipelineDashboardSlice,
  wormholeCreatePipelineSlice: wormholeCreatePipelineSlice,
  oneplatformV2ProfilerSlice: profilerSlice,
  authSlice: authSlice,
  modals: modalReducer,
  userManagement: userManagementReducer,
  roles: rolesReducer,
  role: roleReducer,
  auth:authReducer,
  deduplicationWorkflowData:deduplicationWorkflowData,
  biPortal: biPortalSlice,
});

const rootReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'RESET_ALL': {
      state = undefined;
      break;
    }
    case 'RESET_EXCEPT_PROJECT_MODAL_DATA': {
      const { ProjectModalData, authSlice } = state || {}; 
      state = { ProjectModalData, authSlice };
      break;
    }
    default:
      break;
  }
  return appReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
